// extracted by mini-css-extract-plugin
module.exports = {"NavigationControls":"NavigationControls_NavigationControls__2goOr","Navigation":"NavigationControls_Navigation__3UFwR","Next":"NavigationControls_Next__waahE"};